export enum UserAssetsTransferDialogState {
    AssetValidation = 'AssetValidation',
    TransferAssets = 'TransferAssets',
    AssetValidationFail = 'AssetValidationFail',
    TransferAssetsFail = 'TransferAssetsFail',
}
